export default function Hidden({ props }) {
    const { register, name } = props

    return <input type="hidden" name={name} ref={register} />
}
